<!-- Dynamic tenant logo component -->
<template>
  <!-- v-if: with no logo resolved, render nothing. An empty src="" makes the
       browser re-request the current page as an image. -->
  <img
    v-if="logoPath"
    :src="logoPath"
    :alt="tenantName + ' logo'"
    :class="logoClass"
    @error="handleImageError"
  />
</template>

<script>
import { getAssetPath, getTenantName } from "@/config/tenant";

export default {
  name: "TenantLogo",
  props: {
    logoClass: {
      type: String,
      default: "",
    },
    fallbackLogo: {
      // Deliberately NOT "/logo.svg": that file is the Partick Thistle Youth
      // Academy mark and ships identically to every tenant, so the old default
      // showed one club's badge to another whenever a tenant's own logo was
      // missing or failed to load. An empty string renders nothing instead.
      type: String,
      default: "",
    },
  },
  data() {
    return {
      logoPath: "",
      tenantName: getTenantName(),
      imageError: false,
    };
  },
  mounted() {
    this.setLogoPath();
  },
  methods: {
    setLogoPath() {
      // Get tenant-specific logo path
      const tenantLogo = getAssetPath("logo");
      this.logoPath = tenantLogo || this.fallbackLogo;
    },
    handleImageError() {
      if (!this.imageError) {
        this.imageError = true;
        this.logoPath = this.fallbackLogo;
      }
    },
  },
};
</script>
